// Cart validation rules. Each rule triggers when condition() is true and blocks
// checkout when validate() returns false, showing message to the user.
// items: array of { vendor: string, tags: string[] }
const CART_RULES = [
  {
    condition: (items) => items.some((i) => i.vendor === 'Sandnes Garn' && i.tags.includes('Wzory')),
    validate: (items) => items.some((i) => i.vendor === 'Sandnes Garn' && i.tags.includes('Włóczki')),
    message: 'Wzory Sandnes Garn można zamawiać wyłącznie razem z włóczkami Sandnes Garn. Dodaj odpowiednią włóczkę Sandnes Garn do koszyka.',
  },
];

function readCartItems(scriptId) {
  const el = document.getElementById(scriptId);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent).items;
  } catch {
    return null;
  }
}

function validateItems(items) {
  for (const rule of CART_RULES) {
    if (rule.condition(items) && !rule.validate(items)) {
      return rule.message;
    }
  }
  return null;
}

function setCartError(errorId, message) {
  const el = document.getElementById(errorId);
  if (el) el.textContent = message;
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('#CartDrawer-Checkout, #checkout');
  if (!button) return;

  const isDrawer = button.id === 'CartDrawer-Checkout';
  const dataScriptId = isDrawer ? 'CartDrawerValidationData' : 'CartValidationData';
  const errorDivId = isDrawer ? 'CartDrawer-CartErrors' : 'cart-errors';

  const items = readCartItems(dataScriptId);
  if (!items) {
    console.warn('[cart-validation] Cart data not found:', dataScriptId);
    return;
  }

  const errorMessage = validateItems(items);
  if (errorMessage) {
    event.preventDefault();
    setCartError(errorDivId, errorMessage);
  }
});

subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
  setCartError('cart-errors', '');
  setCartError('CartDrawer-CartErrors', '');
});
